module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0065.jpg?v=146e5b58";